import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import PostGroup from 'models/PostGroup';
import PostManagerComponent from 'react/posts/PostManagerComponent';
import BugReportDiscussion from 'react/posts/BugReportDiscussion';

import { Provider } from 'react-redux';

import store from 'react/redux/store/store';

export const PostManager = function(dynamicPostsGroup) {
	this.dynamicPostsGroup = dynamicPostsGroup;
	const theHint = dynamicPostsGroup.find('input:first');

	const props = {
		inputKey: theHint.attr('name'),
		inputValue: theHint.val(),
	};

	const Discussion = dynamicPostsGroup.data('workspace') === true ? BugReportDiscussion : PostManagerComponent;
	props.canModerate = dynamicPostsGroup.data('moderator') === true;
	props.closed = dynamicPostsGroup.data('closed') === true;
	renderIntoContainer(
		<Provider store={store}>
			<Discussion
				postGroup={PostGroup.create({ topics: this.dynamicPostsGroup.data('topics') })}
				{...props}
			/>
		</Provider>
		,
		dynamicPostsGroup[0]
	);
};